module.exports = __webpack_public_path__ + "static/14-2974e022ac0c75272f020807665862d0.svg";